import apiClient from "./axios.config";

const locationService = {
  getAllLocations() {
    return apiClient.get("/website/property/locations");
  },
  getLocationDetails(locationName, cityName) {
    
    return apiClient.get(
      `/website/property/locations/${locationName}/${cityName}`
    );
  },
  getUpdatedLocationDetails(pagetype, locationName, cityName) {
   const detailspayload=
    {
      PageType: pagetype,
     locationName: locationName,
      cityName: cityName
    }
    // console.log("detailspayload",detailspayload)
    return apiClient.get(
      '/website/property/seo-locations', { params: detailspayload }
    );
  }
};

export default locationService;
